import { ValidatorFn, AbstractControl } from '@angular/forms';

export function emailValidator(pattern: RegExp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/i): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const test = (control.value && control.value !== '') ? pattern.test(control.value) : true;
    return test ? null : {email: {value: control.value}};
  };
}
